import React, { Component } from 'react';
import TimeFormat from 'hh-mm-ss';
import { AllHtmlEntities } from 'html-entities';

const HighlightedText = ({
  children,
  highlights,
}) => {
  const text = AllHtmlEntities.decode(children || '');
  return <div>{(text || '').split(' ').map((el, idx) => {
    if (highlights.find(word => el.toLowerCase().includes(word))) {
      return <span key={idx} className='highlight'>{el}&nbsp;</span>;
    } else {
      return <span key={idx}>{el}&nbsp;</span>;
    }
  })}</div>;
};

const Transcript = ({
  cues,
  relevantCues,
  videoId,
  onVideoClick,
  keywords,
  full,
}) => {
  const theCues = (full ? cues : relevantCues.slice(0, 3)).map(cue => {
    if (Array.isArray(cue)) {
      return {
        timestamp: cue[0],
        ct: cue[1],
        text: cue[2],
      };
    }
    return cue;
  });
  return (
      <div className={'transcript' + (full ? ' full' : '')}>
      {theCues.map(cue => {
        return (
            <div className="line" key={cue.timestamp + cue.text}
              onClick={() => {
                onVideoClick(videoId, cue.timestamp);
              }}>
            <div className="time">{TimeFormat.fromS(parseInt(cue.timestamp), "mm:ss")}</div>
            <div className="text"><HighlightedText highlights={keywords}>{cue.text}</HighlightedText></div>
          </div>
        );
      })}
    </div>
  );
};

export default Transcript;



// WEBPACK FOOTER //
// ./src/SearchPage/Transcript.js